




























import { Component, Vue, Prop, Emit } from "vue-property-decorator";
import { NavigationItem } from "@/model/NavigationItem";
import { NAVIGATION_STATUS } from "@/model/NavigationStatus";

@Component
export default class Navigation extends Vue {
  @Prop() active: number;
  @Prop() title: string;
  @Prop() navItems: NavigationItem[];
  @Prop() canjump: boolean;
  activePage: number = 0;
  lockNav: boolean = false;

  created() {
    this.activePage = this.active;
  }

  onChangePage(index: number) {
    if (this.canjump) {
      this.activePage = index;
      this.$emit("changePage", index);
    }
  }
  isActive(status: string) {
    return status === NAVIGATION_STATUS.ACTIVE;
  }
  isRegister(status: string) {
    return status === NAVIGATION_STATUS.REGISTER;
  }
  isRegisterNotComplete(status: string) {
    return status === NAVIGATION_STATUS.REGISTER_NOTCOMPLETE;
  }

  checkLockNavigation() {
    if (this.navItems[0].status != NAVIGATION_STATUS.REGISTER) {
      this.lockNav = true;
    } else {
      this.lockNav = false;
    }
  }
}
